module.exports = __webpack_public_path__ + "img/satt_axlr-grey.3415edc8.png";